import React, { useEffect, useState } from "react";
import { Table, Button, OverlayTrigger, Popover } from "react-bootstrap";
import { apiUrl, baseUrl } from "../../config";
import { fetchAllUser } from "../../service/UserService";
import { Edit, Eye, MessageSquare, Trash } from "lucide-react";
import { Copy } from "react-feather";
import { useToast } from "../toast/ToastProvider";
const PagesList = ({ pages, onEdit, onDelete, onView, handleComments, deletingId }) => {
  const toast = useToast();
  console.log('pg', pages);
  const viewPopover = (
    <Popover id="popover-view">
      <Popover.Body>View Page details</Popover.Body>
    </Popover>
  );
  const editPopover = (
    <Popover id="popover-view">
      <Popover.Body>Edit Page details</Popover.Body>
    </Popover>
  );
  const deletePopover = (
    <Popover id="popover-view">
      <Popover.Body>Delete Page </Popover.Body>
    </Popover>
  );
  const copyPopover = (
    <Popover id="popover-view">
      <Popover.Body>copy Page Link </Popover.Body>
    </Popover>
  );
  const commentsPopover = (
    <Popover id='popover-view'>
      <Popover.Body>
        comments view
      </Popover.Body>
    </Popover>
  )
  
  return (
    <>

      <Table className="custom-employee-table" bordered hover responsive>
        <thead>
          <tr>
            <th>S.No</th>
            <th>UserName</th>
            <th>Image</th>
            <th>Title</th>
            {/* <th>Content</th> */}
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {pages.length > 0 ? (
            pages.map((pages, idx) => {
              return (
                <tr key={pages.id}>
                  <td>{idx + 1}</td>
                  <td>{pages?.username || "NA"}</td>
                  <td>
                    <img
                      src={apiUrl + "/" + pages.bannerImageUrl}
                      className="student-thumbnail"
                      style={{
                        objectFit: "contain",
                        height: "70px",
                        width: "70px",
                      }}
                      alt=""
                    />
                  </td>
                  <td>{pages.title}</td>
                  {/* <td>
                  <div
                    style={{
                      maxWidth: "300px",
                      maxHeight: "20vh",
                      overflowY: "scroll",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    {pages.content}
                  </div>
                </td> */}
                  <td>
                    <OverlayTrigger
                      trigger={["hover", "focus"]}
                      placement="top"
                      overlay={viewPopover}
                    >
                      <Button
                        size="sm"
                        className="me-1"
                        style={{
                          backgroundColor: "#10296C",
                          padding: "5px",
                          borderRadius: "5px",
                          marginRight: "5px",
                        }}
                        onClick={() => onView(pages)}
                      >
                        <Eye />
                      </Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      trigger={["hover", "focus"]}
                      placement="top"
                      overlay={editPopover}
                    >
                      <Button
                        size="sm"
                        variant="warning"
                        className="me-1"
                        style={{
                          padding: "5px",
                          borderRadius: "5px",
                          marginRight: "5px",
                        }}
                        onClick={() => onEdit(pages)}
                      >
                        <Edit />
                      </Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      trigger={["hover", "focus"]}
                      placement="top"
                      overlay={deletePopover}
                    >
                      <Button
                        size="sm"
                        variant="danger"
                        style={{
                          padding: "5px",
                          borderRadius: "5px",
                          marginRight: "5px",
                        }}
                        onClick={() => onDelete(pages.id)}
                        disabled={pages.id === deletingId}
                      >
                        {pages.id === deletingId ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Deleting...
                          </>
                        ) : (
                          <Trash />
                        )}
                      </Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      trigger={["hover", "focus"]}
                      placement="top"
                      overlay={commentsPopover}
                    >
                      <Button
                        size="sm"
                        className="me-1 position-relative"
                        variant="success"
                        style={{
                          padding: "5px",
                          borderRadius: "5px",
                          marginRight: "5px",
                          zIndex:"75",
                        }}
                        onClick={() => handleComments(pages.id)}
                      >
                        <MessageSquare />

                        <span
                          className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                          style={{ fontSize: "10px", }}
                        >
                          {pages.newCommentCount || 0}
                        </span>

                      </Button>
                    </OverlayTrigger>

                    <OverlayTrigger
                      trigger={["hover", "focus"]}
                      placement="top"
                      overlay={copyPopover}
                    >
                      <Button
                        size="sm"
                        variant="primary"
                        style={{
                          padding: "5px",
                          borderRadius: "5px",
                          marginRight: "5px",
                        }}
                        onClick={() => {
                          navigator.clipboard.writeText(
                            // `http://localhost/project/vvrhcs-web/api/pages/${pages.id}`
                            `${baseUrl}/pages/${pages.id}`

                          );
                          toast("URL Copied!", "SUCCESS");
                        }}
                      >
                        <Copy />
                      </Button>
                    </OverlayTrigger>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="6" className="text-center">
                No advertisements found.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};
export default PagesList;